import { theme } from '~/theme';
export const useSxStyles = () => {
  return {
    refDiv: {
      display: 'flex',
      flexGrow: 1,
    },
    root: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      overflow: 'hidden',
    },
    fullAnnouncement: {
      height: '100%',
      '&:before': {
        height: 0,
      },
    },
    dialogContent: {
      paddingTop: 0,
      paddingBottom: theme.spacing(3),
    },
  };
};
